import React, { memo, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { connect } from 'react-redux';
import { t } from 'i18next';

import { getByteLength } from '../../utils';
import ic_Next from '../../assets/imgs/ic_Next.svg?react';
import './styles.css';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import i18n from '../../assets/languages/configs';
import { OrderTicket } from 'types';
import { RootState } from 'redux/reducers/rootReducer';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault('Asia/Tokyo');

/**
 * 時計表示
 */
type ClockDigitalProps = {
    colorFontBottom: string;
    orderTicket?: OrderTicket;
};

const ClockDigital = memo(({ colorFontBottom, orderTicket }: ClockDigitalProps) => {
    const [currentTime, setCurrentTime] = useState(dayjs.tz());
    const navigate = useNavigate();
    const { language } = i18n;

    function refreshClock() {
        setCurrentTime(dayjs.tz());
    }
    useEffect(() => {
        const timerId = setInterval(refreshClock, 1000);
        return function cleanup() {
            clearInterval(timerId);
        };
    }, []);

    const handleTicketDetail = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        event.stopPropagation();
        navigate('/bought/detail', {
            state: {
                orderId: orderTicket?.orderId,
                orderTicketId: orderTicket?.orderTicketId ?? null,
            },
        });
    };

    return (
        <>
            <div className="info-guide">
                <p className="info-note" style={{ color: colorFontBottom }}>
                    {t('ticket-display.note')}
                </p>
                <p className="info-time" style={{ fontFamily: 'NotoSans', color: colorFontBottom }}>
                    {currentTime.format('HH:mm:ss')}
                    {/* <Link to="/bought/active" className='bt-ticket-detail' style={{...fonts.regular, color:textColor }}>{}</Link> */}
                </p>
            </div>
            {orderTicket?.orderId && (
                <div className="bt-ticket-detail" onClick={handleTicketDetail}>
                    {React.createElement(DetailButton, {
                        title: t('ticket-display.detail'),
                        width: 120,
                        height: 39,
                        textColor: colorFontBottom,
                        borderColor: colorFontBottom,
                        language: language,
                    })}
                </div>
            )}
        </>
    );
});

export default connect((state: RootState) => ({
    colorFontBottom: state.currentTheme.colorFontBottom,
}))(ClockDigital);

/**
 * 詳細ボタン
 */

type DetailButtonProps = {
    title?: string;
    width: number;
    height: number;
    textColor: string;
    borderColor: string;
    language: string;
};
const DetailButton = memo(
    ({ title = 'Detail', width, height, textColor, borderColor, language }: DetailButtonProps) => {
        const filet = 40;
        const strokeWidth = 7;
        let fontSize = 70;
        let textLength = (70 * getByteLength(title)) / 2;
        if (language === 'th') {
            textLength = 320;
        } else if (language === 'vi') {
            textLength = 270;
        } else if (language === 'ko') {
            textLength = 270;
        } else if (language === 'id') {
            fontSize = 50;
            textLength = 340;
        }

        return (
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width={width}
                height={height}
                viewBox={`0 0 300 200`}
                className="td-btn"
            >
                <rect
                    x="0"
                    y={strokeWidth / 2}
                    width={320 + textLength}
                    height={200 - strokeWidth}
                    className="background-rect"
                    stroke={borderColor}
                    strokeWidth={strokeWidth}
                    rx={filet}
                    ry={filet}
                />

                <text
                    id={'detailText'}
                    fill={textColor}
                    fontSize={fontSize}
                    x={40 + textLength / 2}
                    y={128}
                    textLength={textLength}
                    textAnchor="middle"
                    fontWeight={'bold'}
                >
                    {title}
                </text>
                {React.createElement(ic_Next, {
                    className: 'next-icon',
                    x: 70 + textLength,
                    y: 68,
                    height: 70,
                    width: 60,
                })}
            </svg>
        );
    },
);
